function TestPage() {
  return (
    <div className="App">
      Test page no lorem ipsum but Who's in bunker? Who's in bunker?
    </div>
  );
}

export default TestPage;
